export interface CheckboxItem {
  value: string | number;
  label: string;
  selected?: boolean;
  colour?: string;
  chipClass?: string; // will add a class appended with -chip to colour accordingly
}
